if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN.CarCollection === "undefined") {
  WDN.CarCollection = (function () {
    var List = {};

    // Factory
    var Dropdown = function (parent, id, output) {
      this.parent = parent;
      this.selector = this.parent.querySelector(`select[data-id="${id}"]`);
      this.output = this.parent.querySelector(`select[data-id='${output}']`);
      this.outputParent = this.parent.querySelector(`.Custom__properties-select[data-id='${output}']`);
      this.labelList = this.parent.querySelectorAll(".Custom__properties-label_value");
      this.id = id;
      this.start();
    };

    var Config = {
      parent: ".Custom__properties",
    };

    var Create = function (id, output) {
      var parent = document
      .querySelector(`${Config.parent}`)

      if (parent) {
        List[id] = new Dropdown(parent, id, output);
      }
    };

    // Setup binds
    Dropdown.prototype.start = function () {
      this.bind();
    };

    // Return value of input dropdown
    Dropdown.prototype.updateActive = function () {
      this.active = this.selector.options[this.selector.selectedIndex].value;
    };

    // Listen for changes
    Dropdown.prototype.bind = function () {
      this.selector.addEventListener("change", this.update.bind(this));
    };

    Dropdown.prototype.update = function () {
      this.updateActive();

      // Find matching list of models from input key
      this.models = Models.filter(function(model) {
        if (model.Brand === this.active) {
          return model;
        }
      }, this)[0];

      this.updateLabel();
      this.render();
    };

    Dropdown.prototype.updateLabel = function(){
      // Update current model name on all matching elements
      this.labelList.forEach(function(label) {
        label.innerHTML = this.active;
      }, this);
      // Update name used for custom product attribute on change
      this.output.name = `properties[${this.active} Model]`;
    }

    // Build new options list
    Dropdown.prototype.render = function () {
      var models = this.models.Models.split(/[,]+/);
      // Clear list
      this.output.innerHTML = "";
      this.outputParent.classList.remove("Hide");
      this.output.innerHTML += `<option value="" disabled selected>${Translations.choose_one}</option>`;
      for (var i = 0; i < models.length; i++) {
        this.output.innerHTML += `<option value="${models[i]}">${models[i]}</option>`;
      }
    };

    return { Create: Create };
  })();
}

WDN.CarCollection.Create("brand", "model")